import ReactDOM from 'react-dom';
import React from 'react';

import { Provider } from 'react-redux';
import Store from '@app/store';
import Layout from '@component/layout';

// Where are we going to mount our application?
const rootNode = document.querySelector('.root-node');

// Subscribe to our Redux stores
Store.subscribe(() => {
  const { route, session } = Store.getState();

  ReactDOM.render(
    <Provider store={Store}>
      <Layout route={route} language={session.language} />
    </Provider>,
    rootNode
  );
});
